import { Filter } from '@/stores/filter/filter';

import Alpine from 'alpinejs';

Alpine.store('filter', new Filter());
